<template>
  <router-view />
  <BaseNotifications />
  <TheCssBreakpointDetector />
</template>

<script setup lang="tsx">
import { BaseNotifications } from "@modernary/mui/components/notifications";
import { TheCssBreakpointDetector, useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { routeNames } from "@/routes";
import LogoConnect from "@/components/LogoConnect.vue";

const appSettingsStore = useAppSettingsStore();
const { setNavigationItems, setApplicationTitleComponent, setSuiteLogoComponent } = useAppNav();

const titleComponent = () => <div>{appSettingsStore.applicationTitle}</div>;
setApplicationTitleComponent(titleComponent);

const connectUrl = import.meta.env.VITE_CONNECT_URL;

if (connectUrl) {
  setSuiteLogoComponent(() => (
    <a
      class="flex items-center ml-1 md:ml-6 pl-3 pr-3 rounded-l-full bg-neutral-300 hover:bg-neutral-400"
      href={connectUrl}
      aria-label="EHA Connect"
    >
      <LogoConnect class="w-10 h-10" background-color="white" foreground-color="#999" />
    </a>
  ));
} else {
  setSuiteLogoComponent(() => (
    <div class="flex items-center ml-1 md:ml-6 pl-3 pr-3 rounded-l-full bg-neutral-300">
      <LogoConnect class="w-10 h-10" background-color="white" foreground-color="#999" />
    </div>
  ));
}

// Nav items should be set one time during app initilization / config.
setNavigationItems([
  {
    label: "home",
    className: "",
    showLabel: false,
    items: [
      { label: "Home", name: routeNames.home },
      // { label: "Contacts", name: routeNames.persons },
    ],
  },
  {
    label: "Facilities",
    className: "",
    items: [{ label: "Facilities", name: routeNames.facilities.facilities }],
  },
  {
    label: "Tanks",
    className: "",
    items: [{ label: "Tanks", name: routeNames.tank.tanks }],
  },
  {
    label: "Compliance Actions",
    className: "",
    items: [{ label: "Compliance Actions", name: routeNames.complianceAction.complianceActions }],
  },
]);
</script>
